export type AgentTypeName =
  | 'RAPP'
  | 'ALTO'
  | 'PURO'
  | 'TEAM_JUNIOR'
  | 'AGENTE_CIEN_PORCIENTO'
  | 'SPLIT_50'
  | 'SPLIT_55'
  | 'SPLIT_60'
  | 'SPLIT_65'
  | 'SPLIT_70'
  | 'SPLIT_75'
  | 'SPLIT_80'
  | 'SPLIT_85'
  | 'SPLIT_90'
  | 'SPLIT_95'
  | 'SPLIT_100';

export const AGENT_TYPE_PERCENTAGES: Record<AgentTypeName, number> = {
  RAPP: 45,
  ALTO: 60,
  PURO: 80,
  TEAM_JUNIOR: 80,
  AGENTE_CIEN_PORCIENTO: 100,
  SPLIT_50: 50,
  SPLIT_55: 55,
  SPLIT_60: 60,
  SPLIT_65: 65,
  SPLIT_70: 70,
  SPLIT_75: 75,
  SPLIT_80: 80,
  SPLIT_85: 85,
  SPLIT_90: 90,
  SPLIT_95: 95,
  SPLIT_100: 100,
};

export const AGENT_LEVEL_TYPE: Record<string, string> = {
  JUNIOR: 'Junior',
  SENIOR: 'Senior',
  BROKER_OWNER: 'Broker Owner',
  BROKER_MANAGER: 'Broker Manager',
};
